import css from 'styled-jsx/css';

const styles = css.global`.custom-carousel.fill-height, .custom-carousel .fill-height {
    width: 100%;
}
.custom-tabs.tabs-container .tab-item {
    flex: 0 0 50% !important;
}

.custom-tabs.tabs-container {
    padding: 32px 15px 24px;
}

.custom-tabs.tabs-container.tab-seguro-auto {
    background: #DEEDF2;
}

@media (min-width: 576px) {
    .custom-tabs.tabs-container .tab-item {
        flex: 0 0 145px !important;
    }
}

@media (min-width: 992px) {
    .custom-tabs.tabs-container {
        padding: 32px 15px 32px;
    }
}`;

export default styles;